import React from 'react';
import { EmailMessageDTO } from '../../../services/apiClient';
import { convertToUserTime } from '../../../utils/dateUtils/convertToUserTime';

interface EmailHeaderProps {
  data: EmailMessageDTO;
  showSubject?: boolean;
  className?: string;
}

const EmailMessageItemHeader: React.FC<EmailHeaderProps> = ({ data }) => {
  return (
    <div>
      <div className="mb-5">
        <label className="text-sm font-medium text-gray-500 dark:text-gray-400 block mb-1">
          From
        </label>
        <span className="text-base text-gray-900 dark:text-gray-100">{data.from}</span>
      </div>

      <div className="mb-5">
        <label className="text-sm font-medium text-gray-500 dark:text-gray-400 block mb-1">
          Subject
        </label>
        <span className="text-base text-gray-900 dark:text-gray-100">{data.subject}</span>
      </div>

      <div className="mb-5">
        <label className="text-sm font-medium text-gray-500 dark:text-gray-400 block mb-1">
          Created Date
        </label>
        <span className="text-base text-gray-900 dark:text-gray-100">
          {convertToUserTime(data.createdUtc?.toString() ?? '', true)}
        </span>
      </div>
    </div>
  );
};

export default EmailMessageItemHeader;
